import type {
  DailyShiftSlotRepository,
  UpdateShiftSlotData,
} from './ports/DailyShiftSlotRepository';

export interface UpdateShiftSlotsInput {
  slots: UpdateShiftSlotData[];
}

export interface UpdateShiftSlotsOutput {
  success: boolean;
  errors?: string[];
}

/**
 * シフト枠を一括更新するUseCase
 * @param repository DailyShiftSlotRepository リポジトリインスタンス
 * @param input UpdateShiftSlotsInput 更新データ
 * @returns Promise<UpdateShiftSlotsOutput> 更新結果
 */
export async function updateShiftSlots(
  repository: DailyShiftSlotRepository,
  input: UpdateShiftSlotsInput
): Promise<UpdateShiftSlotsOutput> {
  try {
    await repository.updateSlots(input.slots);
    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : '更新に失敗しました';
    return { success: false, errors: [errorMessage] };
  }
}
